export class PrefSession {
// Copied from sessions-form.component.ts

    hasHighlights: boolean = false;
    // highlights: new Array<NewPageList>();
    
    hasCustomTitle: boolean = false;
    customTitle: string = null;
    
    allowTopicFavourite: boolean = false;

}


// WEBPACK FOOTER //
// /app/src/app/core/models/prefSession.ts